import { useSelector } from "react-redux";
import Constants from "../Constants";

export function useKiosk() {
  const mode = useSelector(({ queryStrings }) => queryStrings?.mode);
  return mode === Constants.modeType.kiosk;
}
